import { SideBar } from '@/component/SideBar';

const MainLayoutSideBar = () => {
  return <SideBar />;
};

export default MainLayoutSideBar;
